module.exports = __webpack_public_path__ + "media/images/tenor_attribution-637c367b58421afcaa648568ef520fae.png";